var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-select",
        {
          attrs: { "show-search": "" },
          model: {
            value: _vm.issue.project,
            callback: function($$v) {
              _vm.$set(_vm.issue, "project", $$v)
            },
            expression: "issue.project"
          }
        },
        _vm._l(_vm.metadata, function(project) {
          return _c(
            "a-select-option",
            {
              key: project.id,
              attrs: { value: project.id, "filter-option": _vm.filterOption }
            },
            [_vm._v("\n      " + _vm._s(project.name) + "\n    ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "a-select",
        {
          model: {
            value: _vm.issue.type,
            callback: function($$v) {
              _vm.$set(_vm.issue, "type", $$v)
            },
            expression: "issue.type"
          }
        },
        _vm._l(_vm.types, function(type) {
          return _c(
            "a-select-option",
            { key: type.id, attrs: { value: type.id } },
            [_vm._v("\n      " + _vm._s(type.name) + "\n    ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("a-input", {
        model: {
          value: _vm.issue.title,
          callback: function($$v) {
            _vm.$set(_vm.issue, "title", $$v)
          },
          expression: "issue.title"
        }
      }),
      _vm._v(" "),
      _c(
        "a-button-group",
        [
          _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.create } },
            [_vm._v("Create")]
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              on: {
                click: function($event) {
                  return _vm.$emit("cancel")
                }
              }
            },
            [_vm._v("Cancel")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }